import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import englishTranslation from './en/translation.json';
import indonesianTranslation from './id/translation.json';
import frenchTranslation from './fr/translation.json';
import arabicTranslation from './ar/translation.json';
import spanishTranslation from './es/translation.json';
import { initReactI18next } from 'react-i18next';

// If need to check all localization visually use this package
// import emoji from 'i18next-emoji-postprocessor';

const resources = {
  en: {
    translation: { ...englishTranslation, ...englishTranslation.errorMessages, ...englishTranslation.successMessages },
  },
  id: {
    translation: { ...indonesianTranslation, ...indonesianTranslation.errorMessages, ...indonesianTranslation.successMessages },
  },
  fr: {
    translation: { ...frenchTranslation, ...frenchTranslation.errorMessages, ...frenchTranslation.successMessages },
  },
  ar: {
    translation: { ...arabicTranslation, ...arabicTranslation.errorMessages, ...arabicTranslation.successMessages },
  },
  es: {
    translation: { ...spanishTranslation, ...spanishTranslation.errorMessages, ...spanishTranslation.successMessages },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  // use this for only development.
  // .use(emoji)

  .init({
    // using appendNamespaceToCIMode: true and changing language to cimode is another option to detect those strings already translated (less colorful than the emoji-postprocessor but built-in)
    // appendNamespaceToCIMode: true,
    // lng:"cimode"
    // If need to check all localization visually use postProcess
    // postProcess: 'emoji',
    supportedLngs: ['en', 'id', 'fr', 'ar', 'es'],
    debug: false,
    fallbackLng: 'en',
    lng: typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') || 'en' : 'en',
    resources,
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: false, // to allow using ':' in the translation keys, since it's used in some error messages
  });

export default i18n;
